import { render, staticRenderFns } from "./accessAuthorizationDetaile.vue?vue&type=template&id=848f82ec&scoped=true&"
import script from "./accessAuthorizationDetaile.vue?vue&type=script&lang=js&"
export * from "./accessAuthorizationDetaile.vue?vue&type=script&lang=js&"
import style0 from "./accessAuthorizationDetaile.vue?vue&type=style&index=0&id=848f82ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848f82ec",
  null
  
)

export default component.exports